/**
 *
 * PendingSurveys
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"
import { Button } from "antd"

/* eslint-disable react/prefer-stateless-function */
class PendingSurveys extends React.Component {
  render() {
    const { surveys } = this.props
    return (
      <div className="PendingSurveysComponent">
        <div>
          Tienes{" "}
          <b>
            {surveys.length} {plural("encuesta", surveys.length, "s")}
          </b>{" "}
          {plural("pendiente", surveys.length, "s")} de responder
        </div>
        <div className="PendingSurveysComponent-surveys">
          {surveys.map((s, si) => (
            <div
              className="PendingSurveysComponent-surveys-row"
              key={`pending-survey-dashboard-${si}`}>
              <span>{s.measure_name}</span>
              <Button
                type="primary"
                onClick={() => {
                  window.open(
                    `${process.env.QUESTIONNAIRE_URL}surveys/answers/${s.token}`,
                    "_blank"
                  )
                }}>
                Responder
              </Button>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

PendingSurveys.propTypes = {}

export default PendingSurveys
